import React, {Component} from 'react';

import {Modal, ProgressBar} from 'react-bootstrap';
import {connect} from 'react-redux';
import './Vote.css';

import advertising from '../assets/images/benchvote.webp';

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import {faArrowRight, faTimesCircle} from '@fortawesome/fontawesome-free-solid'

import {submitVote} from "../actions/AuthActions";

import $ from 'jquery';
import ReactDOM from 'react-dom';
import { Trans,withTranslation} from 'react-i18next';
import Footer from "./Footer";
import { getDesktopPickBtn, getUrlWord } from '../util/helpers/Helpers';
import { SHOW_ALL_PLAYERS_FOR_ALL_POS } from '../util/Constants';

class Vote extends Component {

  componentDidMount() {
    // let hash = this.props.location.hash;
    // hash = hash ? hash.replace(/(^#)/g, "") : '';
    let hash = getUrlWord(this.props.match.url, this.props.location.hash);
    this.setState({hash});
    if (this.props.comp && this.props.comp.id !== 0) {
      this.setFieldFromDb();
    }
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.comp.id != this.props.comp.id) {
      this.setFieldFromDb();
    }

    if(this.props.comp && this.props.comp.id > 0 && !window.codeInjectedForEngagementPage) {

      const codeSamples = this.props.comp.codeSnippetsForInjection || [];
      for(let i = 0; i < codeSamples.length; i++) {
        if(codeSamples[i].page === 'global' && codeSamples[i].htmlTagName && codeSamples[i].codeToBeInjected) {
          $(codeSamples[i].htmlTagName).append(codeSamples[i].codeToBeInjected);
        } else if(codeSamples[i].page === 'engagement' && codeSamples[i].codeToBeInjected) {
          $(ReactDOM.findDOMNode(this)).append(codeSamples[i].codeToBeInjected);
        }
      }
      window.codeInjectedForEngagementPage = true;
    }
  }

  setFieldFromDb = () => {
    const {field} = this.props.comp;
    let nPos = 0;
    if (field) {
      nPos = field.lines.reduce((acc, l) => acc + l.positions.length, 0);
    }
    this.setState({
      positions: this.calculatePositionsFromComp(),
      totalPlayers: nPos
    });
  }

  updateWindowDimensions = () => {

    let ps = this.calculatePositionsStyles();

    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
      positionStyles: ps,
      positions: this.calculatePositionsFromComp(),
    });
  }

  calculatePositionsStyles = () => {

    let s = {
      width: 148,
      height: 205,
      margin: 5,
      borders: 2
    };

    let w = this.state && this.state.width ? this.state.width : window.innerWidth;

    s.padding = s.margin * 5;
    if (w <= 570) {
      s.width = 100;
      s.padding = s.margin * 3;
    }
    if (w <= 450) {
      s.width = 85;
      s.margin = 4;
      s.padding = s.margin;
    }

    return s;
  }

  calculatePositionsFromComp = () => {

    const posStyles = this.calculatePositionsStyles();

    const {field, fieldBg, secondaryColor} = this.props.comp;
    if (!field) {
      return [];
    }
    const defaultPositionStyles = {
      width: `${posStyles.width}px`,
      height: `${posStyles.height}px`,
      margin: `${posStyles.margin / 2}px`
    }
    const fieldStyle = {};
    if(fieldBg) {
      // fieldStyle.backgroundImage = `url(${fieldBg.file})`;
    }
    return [
      {
        type: 'container',
        className: 'field',
        style: fieldStyle,
        places: field.lines.map(l => {
          const ret = [];
          if (l.show) {
            ret.push({
              type: 'title',
              text: l.name
            });
          }
          ret.push({
            type: 'line',
            places: l.positions.map(p => {
              const marginLeft = p.marginLeft ? `${p.marginLeft}px` : null;
              const marginRight = p.marginRight ? `${p.marginRight}px` : null;
              const style = {
                ...defaultPositionStyles
              };
              if (marginLeft) {
                style.marginLeft = marginLeft;
              }
              if (marginRight) {
                style.marginRight = marginRight;
              }
              return {
                type: 'position',
                id: p.id,
                text: p.name,
                selectedPlayers: p.selectedPlayersAsObject,
                style
              }
            })
          });
          return ret;
        }).reduce((acc, val) => acc.concat(val), []),
      }
    ];
  }

  calculatePositions = (positionStyles) => {
    return [
      {
        type: 'container',
        className: 'field',
        places: [
          {
            type: 'title',
            text: 'Defenders'
          },
          {
            type: 'line',
            places: [
              {type: 'position', id: 1, text: 'BP'},
              {type: 'position', id: 2, text: 'FB'},
              {type: 'position', id: 3, text: 'BP'}
            ]
          },
          {
            type: 'line',
            places: [
              {type: 'position', id: 4, text: 'HB'},
              {type: 'position', id: 5, text: 'CHB'},
              {type: 'position', id: 6, text: 'HB'}
            ]
          },
          {type: 'title', text: 'Midfielders'},
          {
            type: 'line',
            places: [
              {
                type: 'container',
                className: 'sides-cont',
                style: {
                  width: positionStyles.width + positionStyles.padding,
                  paddingRight: `${positionStyles.padding}px`
                },
                places: [
                  {
                    type: 'container',
                    className: 'sides',
                    style: {
                      width: positionStyles.width
                    },
                    places: [
                      {
                        type: 'image',
                        src: advertising,
                        className: 'field-advertising',
                        num: 3
                      },
                      {
                        type: 'position',
                        className: 'extra-spaced',
                        style: {
                          width: `${positionStyles.width}px`,
                          height: `${positionStyles.height}px`,
                          float: 'initial'
                        },
                        id: 11,
                        text: 'Wing'
                      },
                      {
                        type: 'image',
                        src: advertising,
                        className: 'field-advertising',
                        num: 4
                      }
                    ]
                  }]
              },
              {
                type: 'column',
                places: [
                  {type: 'position', id: 7, text: 'Ruck'},
                  {type: 'position', id: 8, text: 'RR'},
                  {type: 'position', id: 9, text: 'ROV'},
                  {type: 'position', id: 10, text: 'C'}
                ]
              },
              {
                type: 'container',
                className: 'sides-cont',
                style: {
                  width: positionStyles.width + positionStyles.padding,
                  paddingLeft: `${positionStyles.padding}px`
                },
                places: [
                  {
                    type: 'container',
                    className: 'sides',
                    style: {
                      width: positionStyles.width
                    },
                    places: [
                      {
                        type: 'image',
                        src: advertising,
                        className: 'field-advertising',
                        num: 1
                      },
                      {
                        type: 'position',
                        className: 'extra-spaced',
                        style: {
                          width: `${positionStyles.width}px`,
                          height: `${positionStyles.height}px`,
                          float: 'initial'
                        },
                        id: 12,
                        text: 'Wing'
                      },
                      {
                        type: 'image',
                        src: advertising,
                        className: 'field-advertising',
                        num: 2
                      }
                    ]
                  }]
              }
            ]
          },
          {type: 'title', text: 'Forwards'},
          {
            type: 'line',
            places: [
              {type: 'position', id: 13, text: 'HF'},
              {type: 'position', id: 14, text: 'CHF'},
              {type: 'position', id: 15, text: 'HF'}
            ]
          },
          {
            type: 'line',
            places: [
              {type: 'position', id: 16, text: 'FP'},
              {type: 'position', id: 17, text: 'FF'},
              {type: 'position', id: 18, text: 'FP'}
            ]
          }
        ]
      },
      {
        type: 'container',
        className: 'interchange-pos desktop',
        minWidth: '400',
        places: [
          {type: 'title', text: 'Interchange'},
          {
            type: 'line',
            className: 'interchange-1',
            places: [
              {type: 'position', id: 19, text: 'INTERCHANGE', hideText: true},
              {type: 'position', id: 20, text: 'INTERCHANGE', hideText: true},
              {type: 'position', id: 21, text: 'INTERCHANGE', hideText: true},
              {type: 'position', id: 22, text: 'INTERCHANGE', hideText: true}
            ]
          }
        ]
      },
      {
        type: 'container',
        className: 'interchange-pos mobile',
        minWidth: '400',
        places: [
          {type: 'title', text: 'Interchange'},
          {
            type: 'line',
            className: 'interchange-cont',
            places: [
              {
                type: 'line',
                className: 'interchange-1',
                places: [
                  {type: 'position', id: 19, text: 'INTERCHANGE', hideText: true},
                  {type: 'position', id: 20, text: 'INTERCHANGE', hideText: true},
                ]
              },
              {
                type: 'line',
                className: 'interchange-2',
                places: [
                  {type: 'position', id: 21, text: 'INTERCHANGE', hideText: true},
                  {type: 'position', id: 22, text: 'INTERCHANGE', hideText: true}
                ]
              }
            ]
          }
        ]
      }
    ]
  }


  constructor(props) {

    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSelectPlayer = this.handleSelectPlayer.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.calculatePositionsStyles = this.calculatePositionsStyles.bind(this);

    let ps = this.calculatePositionsStyles();

    this.state = {
      show: false,
      selectedPos: null,
      positionStyles: ps,
      positions: [],
      selectedPlayers: [],
      totalPlayers: 0,
      replacing: false,
      playersList: null
    };
  }

  camelize = (str) => `${str.substring(0, 1).toUpperCase()}${str.substring(1).toLowerCase()}`;

  renderFieldPart(pos, styles) {

    const {comp} = this.props;
    switch (pos.type) {

      case 'title': {

        return <div key={JSON.stringify(pos)}
                    className={`${pos.type} ${pos.className ? pos.className : ''}`}
                     style={{color: comp.primaryColor}}
        >{pos.text}</div>;
      }
      case 'container': {

        return <div key={JSON.stringify(pos)} className={pos.className} style={pos.style}>
          {pos.places.map(op => this.renderFieldPart(op, styles))}
        </div>;
      }
      case 'line': {
        const nPlaces = pos.places.length;
        let lineWid = pos.places.reduce((accumulator, el) => {
          const wid = parseInt(el.style.width.replace("px", ""));
          let mLeft = parseInt(el.style.margin.replace("px", ""));
          if (el.style && el.style.marginLeft) {
            mLeft = parseInt(el.style.marginLeft.replace("px", ""));
          }
          let mRight = parseInt(el.style.margin.replace("px", ""));
          if (el.style && el.style.marginRight) {
            mRight = parseInt(el.style.marginRight.replace("px", ""));
          }
          return accumulator + wid + mLeft + mRight;
        }, 0);
        const linePlaces = pos.places.map(op => this.renderFieldPart(op, styles));
        //TODO: remove width calculations
        return <div key={JSON.stringify(pos)} className={`${pos.type} ${pos.className ? pos.className : ''}`}
                    //style={{width: `${lineWid + styles.borders}px`}}  // width is being calculated and set to center the boxes, achieved using inline-blocks
        >
          {linePlaces}
        </div>;
      }
      case 'column': {
        const linePlaces = pos.places.map(op => this.renderFieldPart(op, styles));

        return <div key={JSON.stringify(pos)} className={pos.type}
                    style={{width: `${styles.width + styles.margin}px`}}
        >
          {linePlaces}
        </div>;
      }
      case 'image': {

        return <div key={JSON.stringify(pos)} className={`${pos.className}-cont`}>
          <img className={pos.className} src={pos.src}/>
        </div>;
      }
      case 'position': {

        let used = this.state.selectedPlayers.find(p => pos.id === p.position.id);

        if (!used) {

          return (<div key={JSON.stringify(pos)} className={`${pos.type} ${pos.className ? pos.className : ''}`}
                       onClick={() => this.handleShow(pos, false)}
                       style={{...pos.style,borderColor: (this.props.comp.borderColor ? this.props.comp.borderColor : '#ffffff'),backgroundColor:(this.props.comp.backgroundColor?this.props.comp.backgroundColor:''),color:(this.props.comp.primaryColor?this.props.comp.primaryColor:'')}}
          ><div className='position-placeholder'><span className='position-plus'></span>{pos.type && !pos.hideText ? pos.text : ''}</div></div>)

        } else {

          let usedBy = used.player;

          return (
            <div key={JSON.stringify(pos)} className={`${pos.type} ${pos.className ? pos.className : ''} used`}
                 onClick={() => this.handleShow(pos, true)}
                 style={{...pos.style,borderColor: (this.props.comp.borderColor ? this.props.comp.borderColor : '#ffffff'),backgroundColor:(this.props.comp.backgroundColor?this.props.comp.backgroundColor:''),color:(this.props.comp.primaryColor?this.props.comp.primaryColor:'')}}
            >
              <div className={'remove'} style={{
                width: styles.width - 2,
                height: this.state.positionStyles.height - 2
              }}
              >
                <FontAwesomeIcon icon={faTimesCircle}/>
              </div>
              <div className={'selected-player'}>
                <div style={{backgroundImage: `url(${usedBy.headshotSmall})`,
                  height: ``}}
                     className={'head'}
                />
                <div className={'name'}>
                  <div className={'firstname custom-vote-colour'}>{usedBy.firstname}</div>
                  <div className={'lastname custom-vote-colour'}>{usedBy.lastname}</div>
                </div>
                <div className={'role'}>{pos.type && !pos.hideText ? pos.text : ''}</div>
              </div>
            </div>)
        }
      }
    }
  }

  renderField = (positions, positionStyles) => {

    return positions.map(pos => this.renderFieldPart(pos, positionStyles));
  }

  handleSubmit = () => {

    const {selectedPlayers, totalPlayers, hash} = this.state;
    const nSelPlayers = selectedPlayers.length;

    if (nSelPlayers < totalPlayers) {
      return;
    }

    // gather positions to sort selections based on position id added
    const {field} = this.props.comp;
    let positionOrder = [];
    if (field && field.lines) {
      field.lines.forEach(line => {
        if(line && line.positions) {
          line.positions.forEach(pos => {
            if (pos.id) {
              positionOrder.push(pos.id);
            }
          });
        }
      });
    }

    const positionLength = positionOrder.length;
    if (nSelPlayers !== positionLength) {
      return;
    }

    // sort selections based on collected positions
    let selectionsSorted = [];
    positionOrder.forEach(idPos => {
      selectedPlayers.forEach(sel => {
        if (sel && sel.position && sel.position.id && sel.position.id === idPos) {
          selectionsSorted.push(sel);
        }
      });
    });

    if (positionLength !== selectionsSorted.length) {
      return;
    }

    let cleanSelection = selectionsSorted.map(s => {
      return {
        idPosition: s.position.id,
        idPlayer: s.player.id
      }
    })

    localStorage.removeItem('dynamicRenderUrl');

    this.props.dispatch(submitVote(
      {votes: cleanSelection, idCompetition: this.props.comp.id},
      hash,
      this.props.dispatch
    ));
  }

  handleClose = () => {
    this.setState({show: false});
  }

  handleShow = (selectedPos, replacing) => {

    const {selectedPlayers} = this.state;
    const {comp} = this.props;

    if (!comp)
      return;

    if (replacing) {

      let newSelectedPlayers = this.state.selectedPlayers.filter(sp => sp.position.id !== selectedPos.id);

      this.setState({
        selectedPos: null,
        show: false,
        replacing: false,
        selectedPlayers: newSelectedPlayers
      });

      return;
    }

    let playersList = null;
    if (selectedPos && selectedPos.selectedPlayers) {
      playersList = selectedPos.selectedPlayers.map(p => {
        if (selectedPlayers.find(p2 => p2.player.id === p.id) && (!SHOW_ALL_PLAYERS_FOR_ALL_POS
                    || !SHOW_ALL_PLAYERS_FOR_ALL_POS.includes(comp.id))) {
          return null;
        }
        return (
          <div key={p.id} className={'player'} onClick={() => this.handleSelectPlayer(p)}>
            <div className={'pl-head-cont'}>
            <div style={{backgroundImage: `url(${p.headshotSmall})`,
                  height: ``}}
                     className={'pl-image'}
                />
              {/* <img src={p.headshotSmall} className={'pl-image'}/> */}
            </div>
            <div className={'pl-name'}>{`${p.firstname}`} <span>{`${p.lastname}`}</span></div>
          </div>
        );
      })
    }

    this.setState({
      selectedPos: selectedPos,
      show: true,
      replacing: replacing,
      playersList
    });
  }

  handleSelectPlayer = (player) => {

    if (!this.props.comp)
      return;

    let selPl = this.state.selectedPlayers.slice();

    selPl.push({
      player: player,
      position: this.state.selectedPos
    })

    this.setState({
      selectedPos: null,
      selectedPlayers: selPl,
      show: false,
    });
  }

  render() {

    const showOnlyDesktopPickBtn = getDesktopPickBtn();

    const {vote,t} = this.props;
    const positions = this.state.positions;
    const comp = this.props.comp;
    const fieldBg = comp.fieldBg;
    if(!comp.id)
      return null;

    let noBorderRadius = (comp && comp.defaultShape == 2);

    const {selectedPos, selectedPlayers, totalPlayers, playersList} = this.state;

    const nSelPlayers = selectedPlayers.length;
    const percent = Math.ceil(100 / totalPlayers * nSelPlayers);

    const btnStyles = {};
    if(nSelPlayers === totalPlayers) {
      btnStyles.backgroundColor = comp.buttonColor;
    }

    // BACKGROUD IMAGE
    // const {field, fieldBg, secondaryColor} = this.props.comp;
    // if (!field) {
    //   return [];
    // }
    // const defaultPositionStyles = {
    //   width: `${posStyles.width}px`,
    //   height: `${posStyles.height}px`,
    //   margin: `${posStyles.margin / 2}px`,
    // }
    const fieldStyles = {};
    if(fieldBg) {
      fieldStyles.backgroundImage = `url(${fieldBg.file})`;
      // fieldStyles.height = `${window.innerHeight - 60}px`; // HEADER AND FOOTER
    }

    let submitButtonText = t('submit');

    if (vote && vote.submitting) {
      submitButtonText = t('submitting');
    }

    return (
      <div className={(noBorderRadius ? 'no-border-radius' : '')}>
        <div className='app' id='app-page-2'>
          <div className={'header'}>
            {/* <div className={'title'}>Pick your best {totalPlayers}</div> */}
            <div className={`btn-cont ${nSelPlayers === totalPlayers ? 'ready' : ''}`}
                 onClick={this.handleSubmit}
            >
              <em><Trans i18nKey="submit" /></em>
              <FontAwesomeIcon icon={faArrowRight}
                               className={`submit-arr`}
              />
            </div>
          </div>
          <div className={'progress-container'}>
            <ProgressBar now={percent}/>
            {/* <div className={'legend'}>{nSelPlayers} OUT OF {totalPlayers} PLAYERS SELECTED</div> */}
            <div className={'legend'}>{nSelPlayers} <Trans i18nKey="out_off" /> {totalPlayers}  <Trans i18nKey="players_selected" /></div>
          </div>
          <div className={'field-container'} style={fieldStyles}>
            {this.renderField(positions, this.state.positionStyles)}


          <div className={(showOnlyDesktopPickBtn ? 'main-submit-cont-desktop' : 'main-submit-cont')} style={{background: 'none'}}>
            <div style={{backgroundColor: comp.buttonColor, color: comp.secondaryColor}}
            className={`primary pick-now-btn ${nSelPlayers === totalPlayers ? 'ready' : ''}`}
                 onClick={this.handleSubmit}>
              {submitButtonText}
              {/* <FontAwesomeIcon icon={faArrowRight} className={`submit-arr`}/> */}
            </div>
          </div>
          </div>
        </div>
        {/* {vote.submitting ? (
          <Modal show={true}>
            <Modal.Body>
              <div className={'submitting'}>
                Submitting vote...
              </div>
            </Modal.Body>
          </Modal>
        ) : null} */}
        {comp ? (
          <Modal show={this.state.show} onHide={this.handleClose} dialogClassName={(noBorderRadius ? 'no-border-radius' : '')}>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <div>
                <div className={'lightbox-head'}>
                {selectedPos?selectedPos.text:''}
                {/* <Trans i18nKey="position_4" /> */}
                  <span><Trans i18nKey="select_player" /></span>
                </div>
                {/* <div className={'lightbox-filter'}>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">@</span>
                    <input type="text" class="form-control" placeholder="Search Player Name" aria-describedby="basic-addon1" />
                  </div>
                </div> */}
                {/* <div className={'progress-container'}>
                  <ProgressBar now={percent}/>
                  <div className={'legend'}>{nSelPlayers}/{totalPlayers} Choosen</div>
                </div> */}
                {/* <div className={'lightbox-for'}>
                  <div className={'the-place'}>
                    {selectedPos ? selectedPos.text : ''}
                  </div>
                  <div className={'the-legend'}>
                    Choose an option for<br/>
                    position {selectedPos ? selectedPos.text : ''}
                  </div>
                </div> */}
                <div className={'lightbox-list'}>
                  {playersList}
                </div>
              </div>
            </Modal.Body>
          </Modal>
        ) : null}

        <Footer tncs={comp.tncs} privacypolicy={comp.privacypolicy} showMadeWithBv={comp.showMadeWithBv} />

      </div>
    );
  }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {

  const prj = state.Project;
  return {
    ...ownProps,
    comp: state.default.bulldogs.competition,
    vote: state.default.bulldogs.vote,
    locale: state.default.locale
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Vote));
